import { VStack } from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { Field } from 'formik';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { dropDownFormStyle } from 'components/forms/new/formStyles';

const TimezoneField = ({
    values,
    setFieldValue,
    timeZoneList,
    FormFieldWithTooltip,
}) => {
    const { darkMode } = useSelector((state) => state.settings);

    const timezoneOptions = useMemo(() => {
        const utcOption = { id: 'UTC', timeZone: 'UTC' };
        return [utcOption, ...timeZoneList];
    }, [timeZoneList]);

    return (
        <FormFieldWithTooltip
            label="Timezone"
            tooltipLabel="Select your preferred timezone. All dates and times will be displayed relative to this timezone."
            fieldKey="timezone">
            <Field>
                {({ field }) => (
                    <VStack width="100%" alignItems="normal">
                        <Select
                            {...field}
                            tabSelectsValue
                            openMenuOnFocus
                            options={timezoneOptions}
                            value={timezoneOptions.find(
                                (o) =>
                                    o.timeZone === values?.timeZone?.timeZone,
                            )}
                            getOptionLabel={(o) => o.timeZone}
                            getOptionValue={(o) => o.timeZone}
                            chakraStyles={dropDownFormStyle(darkMode)}
                            onChange={(e) => {
                                setFieldValue('timeZone', {
                                    ...values?.timeZone,
                                    timeZone: e.timeZone,
                                });
                            }}
                            selectedOptionColor="brand"
                            size="md"
                        />
                    </VStack>
                )}
            </Field>
        </FormFieldWithTooltip>
    );
};

export default TimezoneField;
